import { createContext } from 'react';
import { ISettingsTransactionsDto } from '@shared/api';
import { emptyFunc } from '@shared/react';
import { PaginationOptions } from '@features/Pagination';
import { ITransactionDesc } from './TransactionsTableProvider';

type DateRange = [string | null, string | null];

interface ILogo {
    link: string;
    symbol: string;
}

export interface ITransactionsTableContext {
    dateRange: DateRange;
    transactionTypes: string[];
    transactions: ISettingsTransactionsDto[];
    transactionsLoading: boolean;
    arrayWithLogos: ILogo[];
    logoLoading: boolean;
    paginationOptions: PaginationOptions | null;
    sortFieldName: string;
    desc: ITransactionDesc | null;
    handleTransactionsSort: (fieldName: string) => void;
    onTransactionViewClick: (transaction: ISettingsTransactionsDto) => void;
    setTransactionsIdentifier: (symbol: string) => void;
    setCusip: (cusip: string) => void;
    setDateRange: (range: DateRange) => void;
    setTransactionTypes: (transactionTypes: string[]) => void;
}

export const TransactionsTableContext = createContext<ITransactionsTableContext>({
    dateRange: [null, null],
    transactions: [],
    transactionTypes: [],
    transactionsLoading: false,
    arrayWithLogos: [],
    logoLoading: false,
    paginationOptions: null,
    sortFieldName: '',
    desc: null,
    handleTransactionsSort: emptyFunc,
    onTransactionViewClick: emptyFunc,
    setTransactionsIdentifier: emptyFunc,
    setCusip: emptyFunc,
    setDateRange: emptyFunc,
    setTransactionTypes: emptyFunc,
});
